module.exports = __webpack_public_path__ + "static/media/superai_text_white_md.6deb050d.png";